<script lang="ts">export let size = "20";
const height = size;
</script>

<svg {height} style="fill: currentColor" viewBox="0 0 22 23" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M2.474 1.911a1.179 1.179 0 1 0-2.357 0v19.178c0 .65.528 1.178 1.179 1.178h19.178a1.179 1.179 0 0 0 0-2.357H2.473zM16.063 4.32a1.57 1.57 0 0 0-2.221.409l-4.837 7.253L6.673 9.65a1.573 1.573 0 1 0-2.225 2.224l3.688 3.686a1.572 1.572 0 0 0 2.42-.238l4.999-7.5 3.844 2.744a1.572 1.572 0 1 0 1.826-2.558z"
	/>
</svg>
